<div class="modal-header">
	<button type="button" class="close" data-dismiss="modal">×</button>
	<h4 class="modal-title">
		{{TR name}}
	</h4>
</div>
<div class="modal-body">
    <div class="row">
	    <div class="col-xs-12">
			<div id="svg-container">
				<select id="js-mode-select" class="form-control css-mode-select">
				{{!--  the values correspond to the modes defined in time_program_model.js  --}}
					<option value="1">{{TR "Mo"}} - {{TR "So"}}</option>
					<option value="2">{{TR "Mo"}} - {{TR "Fr"}}, {{TR "Sa"}} - {{TR "So"}}</option>
					<option value="3">{{TR "Mo"}}, {{TR "Di"}}, {{TR "Mi"}}, {{TR "Do"}}, {{TR "Fr"}}, {{TR "Sa"}}, {{TR "So"}}</option>
				</select>
			</div>
	    </div>
    </div>
{{#each labelsAndIDs}}
    <div class="row">
		{{!--  Zeitleiste  --}}
	    <div class='col-sm-2 p-t-10'><h5>{{this.label}}</h5></div>
	    <div class='col-sm-10 js-timeline-container'>
			<div class="svg-container">
				<svg class="js-timeline-{{this.ID}}" width="100%" height="100%">
					<svg id="js-labels-{{this.ID}}" viewBox="-50 0 2550 200" preserveAspectRatio="xMinYMin meet" style="overflow: visible;">
					</svg>
					<svg viewBox="-50 0 2550 150" preserveAspectRatio="xMinYMax meet" style="overflow: visible;">
						<text font-size="60px" x="-10"  y="150" fill="black">0 </text>
						<text font-size="60px" x="390"  y="150" fill="black">4 </text>
						<text font-size="60px" x="790"  y="150" fill="black">8 </text>
						<text font-size="60px" x="1190" y="150" fill="black">12</text>
						<text font-size="60px" x="1590" y="150" fill="black">16</text>
						<text font-size="60px" x="1990" y="150" fill="black">20</text>
						<text font-size="60px" x="2390" y="150" fill="black">24</text>
					</svg>
					<svg id="js-timeline-{{this.ID}}" class="js-timeline-{{this.ID}}"  viewBox="-50 0 2550 200" preserveAspectRatio="none" >
						<line x1="0" y1="150" x2="2400" y2="150" stroke="black" stroke-width="5"/>
						<line x1="0"    y1="150" x2="0"    y2="80" stroke="black" stroke-width="5"/>
						<line x1="100"  y1="150" x2="100"  y2="100" stroke="black" stroke-width="5"/>
						<line x1="200"  y1="150" x2="200"  y2="100" stroke="black" stroke-width="5"/>
						<line x1="300"  y1="150" x2="300"  y2="100" stroke="black" stroke-width="5"/>
						<line x1="400"  y1="150" x2="400"  y2="80" stroke="black" stroke-width="5"/>
						<line x1="500"  y1="150" x2="500"  y2="100" stroke="black" stroke-width="5"/>
						<line x1="600"  y1="150" x2="600"  y2="100" stroke="black" stroke-width="5"/>
						<line x1="700"  y1="150" x2="700"  y2="100" stroke="black" stroke-width="5"/>
						<line x1="800"  y1="150" x2="800"  y2="80" stroke="black" stroke-width="5"/>
						<line x1="900"  y1="150" x2="900"  y2="100" stroke="black" stroke-width="5"/>
						<line x1="1000" y1="150" x2="1000" y2="100" stroke="black" stroke-width="5"/>
						<line x1="1100" y1="150" x2="1100" y2="100" stroke="black" stroke-width="5"/>
						<line x1="1200" y1="150" x2="1200" y2="80" stroke="black" stroke-width="5"/>
						<line x1="1300" y1="150" x2="1300" y2="100" stroke="black" stroke-width="5"/>
						<line x1="1400" y1="150" x2="1400" y2="100" stroke="black" stroke-width="5"/>
						<line x1="1500" y1="150" x2="1500" y2="100" stroke="black" stroke-width="5"/>
						<line x1="1600" y1="150" x2="1600" y2="80" stroke="black" stroke-width="5"/>
						<line x1="1700" y1="150" x2="1700" y2="100" stroke="black" stroke-width="5"/>
						<line x1="1800" y1="150" x2="1800" y2="100" stroke="black" stroke-width="5"/>
						<line x1="1900" y1="150" x2="1900" y2="100" stroke="black" stroke-width="5"/>
						<line x1="2000" y1="150" x2="2000" y2="80" stroke="black" stroke-width="5"/>
						<line x1="2100" y1="150" x2="2100" y2="100" stroke="black" stroke-width="5"/>
						<line x1="2200" y1="150" x2="2200" y2="100" stroke="black" stroke-width="5"/>
						<line x1="2300" y1="150" x2="2300" y2="100" stroke="black" stroke-width="5"/>
						<line x1="2400" y1="150" x2="2400" y2="80" stroke="black" stroke-width="5" id="append" />
					</svg>
				</svg>
			</div>
	    </div>
	</div>
{{/each}}
</div>

<div class="modal-footer">
	<button id="ct-cancel" type="button" class="btn btn-white" data-dismiss="modal">{{TR "Abbrechen"}}</button>
	<button type="button" class="btn btn-primary" id="js-save">{{TR "Speichern"}}</button>
</div>
